export default __webpack_public_path__ + "static/media/add-with-background.272508ba.svg";